import Vue from 'vue'

export default {
    UPDATE_MESSAGES (state, value) {
        Vue.set(state, 'messages', value);
    },
  SET_MESSAGES (state, value) {
        this.commit('UPDATE_MESSAGES', value);
    },
    SET_SELECTED_MESSAGE (state,  value ) {
      Vue.set(state, 'selectedMessage', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/messages/mutations.js